import { removeSpace } from '../SettingsSyncToCal/SettingsSyncToCalHelper';
import { VALIDATIONCODES } from './SyncToCalendarHelper';

const validateiOSAccountDetails = async (emailId, appleSpecificPassword, syncToCalendarContext) => {
    let validateiOSDetails: any = {};
    validateiOSDetails = {
        operation: 'validate',
        emailId: removeSpace(emailId),
        accountType: 'apple',
        token: removeSpace(appleSpecificPassword),
    }
    const response = await syncToCalendarContext.validateiOSEmail(validateiOSDetails);
    return response;
}

const handleEmailValidation = (validationErrorCode, setEmailErrorMsg) => {
    if (validationErrorCode === VALIDATIONCODES.INVALIDID) {
        setEmailErrorMsg({ invalidError: true, alreadyExistsError: false });
    } else {
        setEmailErrorMsg({ invalidError: false, alreadyExistsError: false });
    }
}

const handlePwdValidation = (validationErrorCode, setPwdErrorMsg) => {
    setPwdErrorMsg(validationErrorCode === VALIDATIONCODES.INVALIDID);
}


export { validateiOSAccountDetails, handleEmailValidation, handlePwdValidation };